import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  AUTHENTICATION_CONFIG,
  AuthenticationConfig,
  authenticationInterceptor,
  EmailModalService,
  error401Interceptor,
  error403Interceptor,
  ERROR_PAGE_CONFIG,
  HEADER_MENU_PROVIDER,
  IErrorPageConfig,
  ModalNotificationService,
  SIDE_NAV_PROVIDER,
  ToasterService,
} from '@maersk-global/angular-shared-library';
import { SideNavMenuService } from './common/services/side-nav-menu/side-nav-menu.service';
import { HeaderMenuService } from './common/services/header-menu/header-menu.service';
import { SharedRecoveryCaseService } from './shared-recovery-case-service';
import {
  ApplicationConfigService,
  AuthService,
  AutomaticRecoveryCaseConfigService,
  BlobService,
  BlobsService,
  BookingService,
  CPInsightsService,
  CaseAndWorkOrderService,
  CaseDamageDetailsService,
  CaseDocumentService,
  CaseService,
  CommonService,
  ContainerProtectService,
  ContainersService,
  CustomerRecoveryClaimService,
  EmailService,
  EmailTemplateService,
  FeaPreService,
  FeaTariffService,
  FileUploadService,
  InvoiceDetailService,
  LiabilityLetterService,
  LiabilityPartyService,
  LiablePartyTypeService,
  MasterDataService,
  MaterialCodeService,
  NotificationService,
  RecoveryCaseDocumentService,
  RecoveryCaseService,
  RecoveryInspectionService,
  ShopService,
  UserService,
  WorkOrderAndLineItemsService,
  WorkOrderLineItemDetailService,
} from './common/api';
import { HelpAndFaqService } from './common/services/help-and-faq/help-and-faq.service';
import { SharedCustomerRecoveryCaseService } from './components/customer-recovery/shared-customer-recovery-case.service';
import { SharedVendorRecoveryCaseService } from './components/vendor-recovery/shared-vendor-recovery-case.service';
import { SharedDataService } from './shared-data-service';
import { environment } from '../environments/environment';
import { ApplicationConfig } from '@angular/core';
import { UserPreferencesService } from './common/services/user-preferences/user-preferences.service';
import { EmailTemplatePlaceholderService } from './email-template-placeholder.service';
import { apiVersionInterceptor } from './common/interceptors/api-version.interceptor';
import { DcrpAuthorizationService } from './common/services/authorization/dcrp-authorization.service';
import { idTokenInterceptor } from './common/interceptors/id-token.interceptor';
import { SharedFeaRecoveryCaseService } from './components/fea-recovery/shared-fea-recovery-case.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { archivalRetryInterceptor } from './common/interceptors/archival-retry.interceptor';
import { AutoInvoiceConfigurationDataManager } from './components/auto-invoice-configuration/auto-invoice-configuration-data-manager';
import { DatePipe } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        error401Interceptor,
        error403Interceptor,
        authenticationInterceptor,
        apiVersionInterceptor,
        idTokenInterceptor,
        archivalRetryInterceptor,
      ])
    ),
    { provide: SIDE_NAV_PROVIDER, useClass: SideNavMenuService },
    { provide: HEADER_MENU_PROVIDER, useClass: HeaderMenuService },
    ModalNotificationService,
    ToasterService,
    EmailModalService,
    ApplicationConfigService,
    CommonService,
    CustomerRecoveryClaimService,
    CaseService,
    MaterialCodeService,
    SharedCustomerRecoveryCaseService,
    SharedVendorRecoveryCaseService,
    WorkOrderAndLineItemsService,
    SharedDataService,
    SharedRecoveryCaseService,
    HelpAndFaqService,
    RecoveryCaseService,
    CaseDocumentService,
    ContainersService,
    ContainerProtectService,
    BlobsService,
    EmailService,
    EmailTemplateService,
    UserPreferencesService,
    EmailTemplatePlaceholderService,
    DcrpAuthorizationService,
    AuthService,
    UserService,
    CaseAndWorkOrderService,
    CaseDamageDetailsService,
    RecoveryInspectionService,
    RecoveryCaseDocumentService,
    NotificationService,
    LiabilityLetterService,
    LiabilityPartyService,
    InvoiceDetailService,
    BookingService,
    WorkOrderLineItemDetailService,
    BlobService,
    SharedFeaRecoveryCaseService,
    ShopService,
    CPInsightsService,
    MasterDataService,
    FeaTariffService,
    AutomaticRecoveryCaseConfigService,
    AutoInvoiceConfigurationDataManager,
    LiablePartyTypeService,
    FeaPreService,
    FileUploadService,
    {
      provide: AUTHENTICATION_CONFIG,
      useValue: {
        authority: environment.authority,
        clientId: environment.clientId,
        postLoginRedirectUri: environment.postLoginRedirectUri,
        storage: { type: 'localStorage' },
        scopes: ['openid', 'email', 'profile'],
        consumerKey: environment.consumer_key,
        inactivityLogoutSeconds: environment.inactivityLogoutSeconds,
        refreshTokenBeforeSeconds: environment.refreshTokenBeforeSeconds,
      } as AuthenticationConfig,
    },
    {
      provide: ERROR_PAGE_CONFIG,
      useValue: {
        raiseAnIncidentURL:
          'https://maersk.service-now.com/end_user_portal?id=report_issue&sys_id=3ee96e21fbe95650b643f197beefdcd0',
      } as IErrorPageConfig,
    },
    DatePipe,
  ],
};
